import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { NewsArticleService } from './news-article.service';
import { NewsArticle } from './news-article';

@Injectable({
  providedIn: 'root'
})
export class NewsModalGuard implements CanActivate {
  constructor(
    private location: Location,
    private newsArticleService: NewsArticleService
    ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkModalOpen(url);
  }

  checkModalOpen(url: string): boolean {
    if (!this.newsArticleService.isNewsModalOpen) {
      return true
    } else {
      this.newsArticleService.previousURL = url;
      this.newsArticleService.setNewsArticleChanged(true, url);
      return false;
    }
    
  }
}
